import { LoadingCards } from '@eventbrite/eds-event-card';
import {
    EventCardShareAction,
    FormattedEvent,
} from '@eventbrite/event-renderer';
import React from 'react';
import { connect } from 'react-redux';
import { DiscoverEventCardProps } from '../../../../components/DiscoverEventCard';
import DiscoverVerticalEventCard from '../../../../components/DiscoverEventCard/Vertical/DiscoverVerticalBrowseEventCard';
import { DiscoverState, ShareOptions } from '../../../../types';
import { HEAP_LOCATION_STRING, UtmOptions } from '../../constants/analytics';

type CategoryPromotedEventsProps = Pick<
    DiscoverEventCardProps,
    'data-testid' | 'onClick'
> & {
    event?: DiscoverEventCardProps['event'];
    isLoading: boolean;
    shareOptions: ShareOptions;
    locale?: string;
    isAuthenticated: boolean;
    utmOptions: UtmOptions;
};

const CategoryPromotedEvents = ({
    event,
    isLoading,
    shareOptions,
    locale,
    isAuthenticated,
    'data-testid': dataTestId,
    utmOptions,
}: CategoryPromotedEventsProps) => {
    if (!event && !isLoading) {
        return null;
    }

    if (isLoading) {
        return (
            <LoadingCards
                style="grid"
                dynamicWidth={true}
                cardCount={1}
                dynamicHeight={true}
            />
        );
    }

    return (
        <DiscoverVerticalEventCard
            locale={locale || 'en_US'}
            statsigLocationString={HEAP_LOCATION_STRING}
            isAuthenticated={isAuthenticated}
            event={event as FormattedEvent}
            isLazyImage
            affCode={'ehometext'}
            data-testid={dataTestId}
            moreActions={
                event && (
                    <EventCardShareAction
                        shareOptions={{
                            ...shareOptions,
                            eventId: event.id,
                            eventName: event.name,
                            eventUrl: event.url,
                            utmOptions,
                            trackingCategory: 'eventcard',
                        }}
                    />
                )
            }
        />
    );
};

const _mapStateToProps = ({ app, user, shareOptions }: DiscoverState) => {
    return {
        locale: app.locale,
        isAuthenticated: user.isAuthenticated,
        shareOptions: shareOptions,
    };
};

export default connect(_mapStateToProps)(CategoryPromotedEvents);
